import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AbstractGridComponent } from '@ui/base/abstract-grid/abstract-grid.component';
import {
    B2BTicketsetLoadListResponse,
} from '@api/models/B2bService/Contract/LoadTickets/b-2-b-ticketset-load-list-response';
import { LocalDateAdapter } from '@core/localization/local-date-adapter';
import { DatePipe } from '@angular/common';
import { PreLoaderModule } from '@ui/feedback/pre-loader/pre-loader.module';
import { NoMatchesComponent } from '@ui/feedback/no-matches/no-matches.component';
import { PaginatorComponent } from '@ui/table/paginator/paginator.component';
import { XlsxService } from '@core/utils/xlsx-service';
import { RxEffects } from '@rx-angular/state/effects';
import { B2bLoadsState } from '../../../../shared/state/b2b-loads-state';
import {
    B2BTicketsetLogfileGetResponse,
} from '@api/models/B2bService/Contract/LoadTickets/b-2-b-ticketset-logfile-get-response';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'b2b-table-number-of-trips-uploads',
    imports: [MatSortModule, MatTableModule, PreLoaderModule, NoMatchesComponent, PaginatorComponent, DatePipe, TranslatePipe],
    templateUrl: './table-number-of-trips-uploads.component.html',
    styleUrl: './table-number-of-trips-uploads.component.scss',
    providers: [XlsxService, RxEffects],
})
export class TableNumberOfTripsUploadsComponent extends AbstractGridComponent<B2BTicketsetLoadListResponse> implements OnChanges {
    @Input()
    public uploads: B2BTicketsetLoadListResponse[];

    readonly #xlsxService: XlsxService = inject(XlsxService);
    readonly #dateFormatService: LocalDateAdapter = inject(LocalDateAdapter);
    readonly #b2bLoadsState: B2bLoadsState = inject(B2bLoadsState);
    readonly #effects: RxEffects = inject(RxEffects);
    public readonly calendarFormat: string = this.#dateFormatService.format.angular;

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes?.uploads?.currentValue) {
            this.displayEntities.data = changes?.uploads?.currentValue;
        }
    }

    public downloadParsingErrorReport(upload: B2BTicketsetLoadListResponse): void {
        this.#effects.register(
            this.#b2bLoadsState.requestReportErrorParsingB2bPrgNumberOfTrips(upload.fileSid),
            (response: B2BTicketsetLogfileGetResponse) => this.#xlsxService.createXlsxFileFromFile(response.logFile),
        );
    }

    public downloadDbErrorReport(upload: B2BTicketsetLoadListResponse): void {
        this.#effects.register(
            this.#b2bLoadsState.requestReportErrorDbB2bPrgNumberOfTrips(upload.fileSid),
            (response: B2BTicketsetLogfileGetResponse) => this.#xlsxService.createXlsxFileFromFile(response.logFile),
        );
    }
}
